import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../core/modules/shared.module';

import { FuseMainComponent } from './main.component';
import { FuseContentComponent } from './content/content.component';
import { FuseToolbarComponent } from './toolbar/toolbar.component';
import { FuseNavbarVerticalComponent } from './navbar/vertical/navbar-vertical.component';
import { FuseFooterComponent } from './footer/footer.component';
import { FuseNavigationModule } from '../core/components/navigation/navigation.module';
import { FuseNavbarVerticalToggleDirective } from './navbar/vertical/navbar-vertical-toggle.directive';


@NgModule({
    declarations: [
        FuseContentComponent,
        FuseMainComponent,
        FuseToolbarComponent,
        FuseNavbarVerticalComponent,
        FuseFooterComponent,
        FuseNavbarVerticalToggleDirective
        ],
    imports: [
        SharedModule,
        RouterModule,
        FuseNavigationModule,
    ],
    exports: [
        FuseMainComponent
    ]
})

export class FuseMainModule {
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/main.module.ts